// Miejsce wydarzenia to wolny tekst (jak w Google Calendar): adres, nazwa albo link
// z Google Maps, czasem poprzedzony nazwą („Udostępnij” w Mapach daje nazwę i link).
// Stąd wyliczamy etykietę do pokazania i link, który od razu prowadzi nawigację.
import { t } from '@/i18n/index.js';

const URL_RE = /https?:\/\/\S+/i;

const isGoogleMaps = (url) => /^(maps\.app\.goo\.gl|goo\.gl)$/i.test(url.hostname)
    || (/(^|\.)google\.[a-z.]+$/i.test(url.hostname) && url.pathname.startsWith('/maps'))
    || /^maps\.google\.[a-z.]+$/i.test(url.hostname);

// Cel z pełnego linku: dokładny punkt miejsca (!3d…!4d…), środek widoku (@lat,lng),
// parametr zapytania albo nazwa z /place/…. Skrócony link nic z tego nie ma.
const destinationOf = (url) => {
    const href = decodeURIComponent(url.href);
    const pin = href.match(/!3d(-?\d+(?:\.\d+)?)!4d(-?\d+(?:\.\d+)?)/);
    if (pin) return `${pin[1]},${pin[2]}`;
    const view = href.match(/@(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
    if (view) return `${view[1]},${view[2]}`;
    for (const key of ['destination', 'query', 'q', 'daddr']) {
        const value = url.searchParams.get(key)?.trim();
        if (value) return value;
    }
    return placeName(url);
};

const placeName = (url) => {
    const place = url.pathname.match(/\/place\/([^/]+)/);
    return place ? decodeURIComponent(place[1]).replace(/\+/g, ' ').trim() || null : null;
};

const directions = (destination) =>
    `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;

// { label, url } albo null przy pustym miejscu.
export const mapsLocation = (location) => {
    const text = (location ?? '').trim();
    if (!text) return null;

    const match = text.match(URL_RE);
    if (!match) return { label: text, url: directions(text) };

    let url;
    try {
        url = new URL(match[0]);
    } catch {
        return { label: text, url: directions(text) };
    }

    const name = text.replace(match[0], ' ').replace(/\s+/g, ' ').trim();
    const google = isGoogleMaps(url);
    const destination = google ? destinationOf(url) : null;
    return {
        label: name
            || (google ? placeName(url) ?? t('planner.maps.pin') : url.hostname.replace(/^www\./, '')),
        url: destination ? directions(destination) : url.href,
    };
};

// Wklejony tekst z „Udostępnij” ma nazwę i link w osobnych liniach — pole jest
// jednowierszowe, więc sklejamy je spacją, zamiast pozwolić przeglądarce zgubić odstęp.
export const flattenPasted = (text) => (text ?? '').replace(/\s*[\r\n]+\s*/g, ' ').trim();
